{
  "apiVersion": "1",
  "context": "",
  "id": "",
  "method": "Tasks->GET",
  "data": {
    "items": [
      {
        "id": "10071",
        "text": "testdfgdfghhhh",
        "author": {
          "id": "ASHAMSIYAROV",
          "name": "Шамсияров А.Д."
        },
        "deadline": "2022-02-03T07:50:19Z",
        "priority": {
          "id": "URGENT",
          "name": "Срочный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "NEW",
          "name": "Не выполнена"
        },
        "customer": {
          "id": "555",
          "name": "(555)Современные медицинские технологииООО"
        },
        "assignees": [
          {
            "assignee": {
              "id": "GKACHAEV",
              "name": "Гаджимари Качаев"
            },
            "status": {
              "id": "NEW",
              "name": "Не выполнена"
            },
            "statusTime": null,
            "result": "Провести выборы"
          }
        ]
      },
      {
        "id": "1097",
        "text": "Провести дезинфекцию",
        "deadline": "2021-09-18T09:27:26Z",
        "result": "Провести дезинфекцию",
        "author": {
          "id": "GKACHAEV",
          "name": "Гаджимари Качаев"
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "NEW",
          "name": "Не выполнена"
        },
        "customer": {
          "id": "555",
          "name": "(555)Современные медицинские технологииООО"
        },
        "assignees": [
          {
            "assignee": {
              "id": "GKACHAEV",
              "name": "Гаджимари Качаев"
            },
            "status": {
              "id": "NEW",
              "name": "Не выполнена"
            },
            "statusTime": null,
            "result": "Провести дезинфекцию"
          }
        ]
      },
      {
        "id": "1135",
        "text": "sdfsdfsf123",
        "deadline": "2021-11-03T02:41:41Z",
        "result": "sdfsdfsf123",
        "author": {
          "id": "ASHAMSIYAROV",
          "name": "Шамсияров А.Д."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "NEW",
          "name": "Не выполнена"
        },
        "customer": {
          "id": "555",
          "name": "(555)Современные медицинские технологииООО"
        },
        "assignees": [
          {
            "assignee": {
              "id": "ASHAMSIYAROV",
              "name": "Шамсияров А.Д."
            },
            "status": {
              "id": "NEW",
              "name": "Не выполнена"
            },
            "statusTime": null,
            "result": "sdfsdfsf123"
          }
        ]
      },
      {
        "id": "1142",
        "text": "new task",
        "deadline": "2021-11-11T02:23:10Z",
        "result": "new task",
        "author": {
          "id": "YSHEGLOV",
          "name": "Юрий Щеглов"
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "NEW",
          "name": "Не выполнена"
        },
        "customer": {
          "id": "555",
          "name": "(555)Современные медицинские технологииООО"
        },
        "assignees": [
          {
            "assignee": {
              "id": "YSHEGLOV",
              "name": "Юрий Щеглов"
            },
            "status": {
              "id": "NEW",
              "name": "Не выполнена"
            },
            "statusTime": null,
            "result": "new task"
          }
        ]
      },
      {
        "id": "10031",
        "text": "",
        "deadline": "2021-12-19T06:29:53Z",
        "result": "",
        "author": {
          "id": "ASHAMSIYAROV",
          "name": "Шамсияров А.Д."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "NEW",
          "name": "Не выполнена"
        },
        "customer": {
          "id": "555",
          "name": "(555)Современные медицинские технологииООО"
        },
        "assignees": []
      },
      {
        "id": "10057",
        "text": "",
        "deadline": "2021-12-20T09:32:25Z",
        "result": "",
        "author": {
          "id": "ASHAMSIYAROV",
          "name": "Шамсияров А.Д."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "NEW",
          "name": "Не выполнена"
        },
        "customer": {
          "id": "555",
          "name": "(555)Современные медицинские технологииООО"
        },
        "assignees": []
      },
      {
        "id": "10072",
        "text": "Необходимо подписать претензию.",
        "deadline": "2021-12-22T05:25:53Z",
        "result": "",
        "author": {
          "id": "VSСHERBAKOV",
          "name": "Владислав Щербаков"
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "NEW",
          "name": "Не выполнена"
        },
        "customer": {
          "id": "555",
          "name": "(555)Современные медицинские технологииООО"
        },
        "assignees": [
          {
            "assignee": {
              "id": "UBOEV",
              "name": "Юрий Боев"
            },
            "status": {
              "id": "NEW",
              "name": "Не выполнена"
            },
            "statusTime": "2021-12-19T05:26:10Z",
            "result": ""
          },
          {
            "assignee": {
              "id": "ASHAMSIYAROV",
              "name": "Шамсияров А.Д."
            },
            "status": {
              "id": "NEW",
              "name": "Не выполнена"
            },
            "statusTime": "2021-12-19T05:26:48Z",
            "result": ""
          }
        ]
      },
      {
        "id": "10098",
        "text": "",
        "deadline": "2021-12-31T06:59:53Z",
        "result": "",
        "author": {
          "id": "ASHAMSIYAROV",
          "name": "Шамсияров А.Д."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "NEW",
          "name": "Не выполнена"
        },
        "customer": {
          "id": "555",
          "name": "(555)Современные медицинские технологииООО"
        },
        "assignees": []
      },
      {
        "id": "223726",
        "text": "что с оплатой? сдали ТЦ на осенней, когда к ларькам приступят? из чего будет? когда планируют закуп?",
        "deadline": "2021-12-27T03:53:53Z",
        "result": "решение будет после НГ что будет с ларьками сейчас космет ремонты в тц которые здают в аренду",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "MEETING",
          "name": "Встреча"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "27872",
          "name": "(27872)ИП Кибизов Сергей Моисеевич"
        },
        "assignees": [
          {
            "assignee": {
              "id": "TMOROZOVA",
              "name": "Морозова Т.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-16T03:23:12Z",
            "result": "решение будет после НГ что будет с ларьками сейчас космет ремонты в тц которые здают в аренду"
          }
        ]
      },
      {
        "id": "227358",
        "text": "6015602397 6600009162 6600009163 6600009164 6600083509 не подписаны СФ, подтяни через ЭДО",
        "deadline": "2021-12-10T05:45:58Z",
        "result": "Маша скинет, как будет в офисе, мне эти доки из ЭДО. завтра возможно.",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "39123",
          "name": "(39123)ЗАО \"НСД\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "Маша скинет, как будет в офисе, мне эти доки из ЭДО. завтра возможно."
          }
        ]
      },
      {
        "id": "228022",
        "text": "идет птичий грипп, никого не допускают на территорию, строиться и ремонты проводить в этом году не будут, весной- и то как отработают зиму. подписать сф и акты сверок",
        "deadline": "2021-12-13T08:18:52Z",
        "result": "пока ничего брать не будут, ничего не строят до марта в Тайланд улетел",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "39313",
          "name": "(39313)ООО \"Птицефабрика Нижневартовская\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "TMOROZOVA",
              "name": "Морозова Т.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": null,
            "result": "пока ничего брать не будут, ничего не строят до марта в Тайланд улетел"
          }
        ]
      },
      {
        "id": "236682",
        "text": "Что решили с работами? берут с материалами или нет?",
        "deadline": "2021-12-10T03:52:06Z",
        "result": "отправить претензию",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "98257",
          "name": "(98257)ООО «СтройРесурс»"
        },
        "assignees": [
          {
            "assignee": {
              "id": "TMOROZOVA",
              "name": "Морозова Т.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "отправить претензию"
          }
        ]
      },
      {
        "id": "237643",
        "text": "счет на плиты, актуализируй все счета с Васей",
        "deadline": "2021-12-10T03:12:36Z",
        "result": "счет на плиты готов",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "37797",
          "name": "(37797)ООО \"Югра-Строй\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "счет на плиты готов"
          }
        ]
      },
      {
        "id": "237740",
        "text": "что с мечетью, какие отгрузки будут на ханты? что с согласованием радиаторов?",
        "deadline": "2021-12-20T03:35:22Z",
        "result": "устанавливают купал, к мечете на сл год",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "MEETING",
          "name": "Встреча"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "27033",
          "name": "(27033)ООО \"Контакт Интернэшнл\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "TMOROZOVA",
              "name": "Морозова Т.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-16T03:22:18Z",
            "result": "устанавливают купал, к мечете на сл год"
          }
        ]
      },
      {
        "id": "237766",
        "text": "что с деньгами и квартирами? Нужен Линолиум 2 машины.",
        "deadline": "2021-12-15T03:38:20Z",
        "result": "до 15.12 не будет денег, а там по квартирам вернемся к вопросу",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "MEETING",
          "name": "Встреча"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "39123",
          "name": "(39123)ЗАО \"НСД\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "TMOROZOVA",
              "name": "Морозова Т.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-16T03:14:04Z",
            "result": "до 15.12 не будет денег, а там по квартирам вернемся к вопросу"
          }
        ]
      },
      {
        "id": "237768",
        "text": "что с лянтором?какие материалы еще поедут? в других городах есть объекты?",
        "deadline": "2021-12-13T03:39:00Z",
        "result": "пока объектов нет",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "MEETING",
          "name": "Встреча"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "62914",
          "name": "(62914)ООО \"АВАЛОН\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "TMOROZOVA",
              "name": "Морозова Т.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-16T03:13:58Z",
            "result": "пока объектов нет"
          }
        ]
      },
      {
        "id": "239902",
        "text": "что со счетом? сделка 1308839",
        "deadline": "2021-12-10T03:22:01Z",
        "result": "так и не оплатили, сегодня уточню",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "77689",
          "name": "(77689)ООО \"ЛИДЕРСТРОЙ\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "так и не оплатили, сегодня уточню"
          }
        ]
      },
      {
        "id": "240301",
        "text": "",
        "deadline": "2021-12-10T03:08:21Z",
        "result": "запустила сделку 1321412",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "33080",
          "name": "(33080)ООО \"Региональные грузоперевозки\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "запустила сделку 1321412"
          }
        ]
      },
      {
        "id": "240308",
        "text": "что со второй заявкой? когда выставим?",
        "deadline": "2021-12-10T03:10:34Z",
        "result": "счет выставили, не прошли по ценам",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "42433",
          "name": "(42433)ООО\"НижневартовскЭлектроСтрой\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "счет выставили, не прошли по ценам"
          }
        ]
      },
      {
        "id": "240709",
        "text": "запусти кирпич, пусть просчитают до конвея",
        "deadline": "2021-12-10T03:08:38Z",
        "result": "счет выставили",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "122089",
          "name": "(122089)ООО «ПРОМТЕХ-СИБИРЬ»"
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "счет выставили"
          }
        ]
      },
      {
        "id": "241462",
        "text": "первчку в порядок",
        "deadline": "2021-12-10T03:25:05Z",
        "result": "подписала яна. готово",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "42433",
          "name": "(42433)ООО\"НижневартовскЭлектроСтрой\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "подписала яна. готово"
          }
        ]
      },
      {
        "id": "243090",
        "text": "что решили по счету?",
        "deadline": "2021-12-10T03:13:35Z",
        "result": "ждем ответ в группе от Вячеслава",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "123639",
          "name": "(123639)ООО ПК \"ЭКОДОМ-МОДУЛЬ\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "ждем ответ в группе от Вячеслава"
          }
        ]
      },
      {
        "id": "243185",
        "text": "что с оплатой? цель чтобы оплатил до конца недели",
        "deadline": "2021-12-10T03:19:13Z",
        "result": "Анатолий вернется 9 дек в город и подпишет",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "27872",
          "name": "(27872)ИП Кибизов Сергей Моисеевич"
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "Анатолий вернется 9 дек в город и подпишет"
          }
        ]
      },
      {
        "id": "243187",
        "text": "Что с оплатой? по графику сумму отправь",
        "deadline": "2021-12-10T03:24:40Z",
        "result": "спд подписали. готово",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "37719",
          "name": "(37719)ООО \"МЕГА-СОДРУЖЕСТВО\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "спд подписали. готово"
          }
        ]
      },
      {
        "id": "243189",
        "text": "по ремиксу оплату подошла, звони им",
        "deadline": "2021-12-10T03:25:11Z",
        "result": "зачет провели. Готово",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "86602",
          "name": "(86602)ООО \"РЕМИКС\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "зачет провели. Готово"
          }
        ]
      },
      {
        "id": "243221",
        "text": "отправь график, и то что оплата подходит",
        "deadline": "2021-12-10T03:27:29Z",
        "result": "спд и акт сверки подписал. готово",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "72452",
          "name": "(72452)ИП Сердогей Янош Яношович"
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "спд и акт сверки подписал. готово"
          }
        ]
      },
      {
        "id": "244029",
        "text": "Актуализируй информацию по счетам",
        "deadline": "2021-12-10T03:28:43Z",
        "result": "готово",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "27033",
          "name": "(27033)ООО \"Контакт Интернэшнл\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "готово"
          }
        ]
      },
      {
        "id": "244030",
        "text": "счет на арматуру выставляй",
        "deadline": "2021-12-10T03:29:24Z",
        "result": "счет на проф трубу готов.",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "27033",
          "name": "(27033)ООО \"Контакт Интернэшнл\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "счет на проф трубу готов."
          }
        ]
      },
      {
        "id": "244090",
        "text": "выставить счет на профнастил и водосточку",
        "deadline": "2021-12-10T03:15:35Z",
        "result": "еще раз корректируем сегодня счет и отгружаем",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "110361",
          "name": "(110361)ООО \"Технологии загородного строительства\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "еще раз корректируем сегодня счет и отгружаем"
          }
        ]
      },
      {
        "id": "244091",
        "text": "выставить счет отталкиваясь от конкурента",
        "deadline": "2021-12-10T03:16:44Z",
        "result": "счет готов",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "122089",
          "name": "(122089)ООО «ПРОМТЕХ-СИБИРЬ»"
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "счет готов"
          }
        ]
      },
      {
        "id": "244141",
        "text": "какой объем будем будем перваначально брать?",
        "deadline": "2021-12-10T03:30:13Z",
        "result": "не прошли по ценам, дешевле не можем найти",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "42433",
          "name": "(42433)ООО\"НижневартовскЭлектроСтрой\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "не прошли по ценам, дешевле не можем найти"
          }
        ]
      },
      {
        "id": "244143",
        "text": "дайте актуальные фото по дверям согласно размерам",
        "deadline": "2021-12-10T03:33:30Z",
        "result": "готово фото и спецухи отправила",
        "author": {
          "id": "TMOROZOVA",
          "name": "Морозова Т.В."
        },
        "priority": {
          "id": "NORMAL",
          "name": "Обычный"
        },
        "type": {
          "id": "TASK",
          "name": "Задача"
        },
        "status": {
          "id": "ACCEPTED",
          "name": "Принята"
        },
        "customer": {
          "id": "85377",
          "name": "(85377)ООО \"Западно-Сибирский ВЦМ\""
        },
        "assignees": [
          {
            "assignee": {
              "id": "KRASSOHINA",
              "name": "Лала (Рассохина) К.В."
            },
            "status": {
              "id": "COMPLETED",
              "name": "Выполнена"
            },
            "statusTime": "2021-12-14T03:33:55Z",
            "result": "готово фото и спецухи отправила"
          }
        ]
      }
    ]
  }
}
